import React from 'react'
import { Spin } from 'antd'

const Loader = () => {
    return (
        <Spin />
    )
}

export default Loader